import React from "react"
import styles from './AppButton.module.css'

export const AppButton = ({type, onClick, value, disabled}) => {
    return <input
    disabled={disabled}
    className={styles.button}
    type={type} 
    value={value} 
    onClick={onClick} />
}